export default [
  {
    path: "/partners",
    name: "Parceiros",
    component: () => import("@/app/modules/partners/pages/extensions/partners.component.vue"),
  },
  {
    path: "/partners/:partner_name/:extension_group",
    name: "Detalhes da extensão",
    component: () => import("@/app/modules/partners/pages/extensions/extension-details.component.vue"),
  },
  // {
  //   path: "/partners/plans",
  //   name: "Extensões - Planos",
  //   component: () =>
  //     import("@/app/modules/partners/pages/partners/plans.component.vue"),
  // },
  // {
  //   path: "/:extension_slug/params",
  //   name: "Preferências de extensão",
  //   component: () =>
  //     import(
  //       "@/app/modules/partners/pages/partners/partner-preferences.component.vue"
  //     ),
  // },
];
